import React, { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import { Form, FormActions, FormDropdown, FormFields, FormTextField, Stack } from "sprint-common-web";

import {
    LanguageSpecificationCodeSource,
    languageSpecificationCodeSourceDropdownOptions
} from "../../../../common/types/LanguageSpecificationCodeSource";
import { useCreateLanguageSpecificationForm } from "./useCreateLanguageSpecificationForm";

export interface CreateFramerateProfileFormProps {
    onCancel(): void;
    onSubmit(): void;
}

export interface CreateLanguageSpecificationFormInputs {
    name: string;
    codeSource: LanguageSpecificationCodeSource;
}

export const CreateLanguageSpecificationForm: FunctionComponent<CreateFramerateProfileFormProps> = (
    props: CreateFramerateProfileFormProps
) => {
    const { errors, control, formState, reset, handleSubmit } = useForm<CreateLanguageSpecificationFormInputs>({
        defaultValues: {
            name: "",
            codeSource: LanguageSpecificationCodeSource.Code
        },
        criteriaMode: "all"
    });

    const { createLanguageSpecification } = useCreateLanguageSpecificationForm();

    const handleCreateLanguageSpecification = async (inputs: CreateLanguageSpecificationFormInputs) => {
        await createLanguageSpecification(inputs);
        props.onSubmit();
        reset();
    };

    const handleCancelButtonClick = () => {
        reset();
        props.onCancel();
    };

    return (
        <Form onSubmit={handleSubmit(handleCreateLanguageSpecification)}>
            <Stack verticalAlign="space-between">
                <FormFields>
                    <FormTextField
                        label="Name"
                        control={control}
                        name="name"
                        errors={errors}
                        rules={{
                            required: "Enter name"
                        }}
                    />
                    <FormDropdown
                        label="Code source"
                        name="codeSource"
                        control={control}
                        errors={errors}
                        options={languageSpecificationCodeSourceDropdownOptions}
                        rules={{
                            required: "Select code source"
                        }}
                    />
                </FormFields>
                <FormActions
                    isLoading={formState.isSubmitting || formState.isValidating}
                    onCancel={handleCancelButtonClick}
                />
            </Stack>
        </Form>
    );
};
